import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import ProdImgPlaceholder from '../../../../../../common/assets/images/merchants/prod-preview-placeholder.svg';
import { ProductStatusTypes } from '../../../../../../common/enums';
import { formatPrice } from '../../../../../../common/global/helpers';
import { config } from '../../../../config';
import { productStatusColor } from '../../../../constants';
import { ProductTypes } from '../../../../enums';
import {
  ProductStatusModel,
  ProductTypeModel,
} from '../../../../models/products';
import { resources } from '../../../../resources/resources';

interface ProductPreviewProps {
  productTypes: ProductTypeModel[];
  producyType: ProductTypes;
  productStatuses: ProductStatusModel[];
  status: ProductStatusTypes;
  name?: string;
  imageContent?: string;
  discountedPrice?: number;
  defaultPrice?: number;
  showPricePreview: boolean;
}

export const ProductPreview = (props: ProductPreviewProps) => {
  const {
    imageContent,
    productTypes,
    producyType,
    name,
    productStatuses,
    status,
    discountedPrice,
    defaultPrice,
    showPricePreview,
  } = props;
  const { t: translate } = useTranslation();
  return (
    <div className="ppreview">
      <div className="ppreview-details">
        <div className="ppreview-image">
          <img
            src={imageContent ?? ProdImgPlaceholder}
            alt={name ?? translate(resources.products.add.placeholders.name)}
          />
        </div>
        <div className="ppreview-info">
          <div className="ppreview-type">
            {productTypes.find(e => e.id === producyType)?.name}
          </div>
          <div className="ppreview-name">
            {name ?? translate(resources.products.add.placeholders.name)}
          </div>
          <div className="ppreview-status">
            <span style={{ backgroundColor: productStatusColor[status] }}>
              {productStatuses.find(e => e.id === status)?.name}
            </span>
          </div>
        </div>
      </div>
      {showPricePreview && (
        <div className="ppreview-price">
          <div className="ppreview-discount">
            {!_.isNil(discountedPrice)
              ? `${formatPrice(discountedPrice)} ${config.currency}`
              : translate(resources.products.add.placeholders.discountedPrice)}
          </div>
          <div className="ppreview-regular">
            {!_.isNil(defaultPrice)
              ? `${formatPrice(defaultPrice)} ${config.currency}`
              : translate(resources.products.add.placeholders.defaultPrice)}
          </div>
        </div>
      )}
    </div>
  );
};
